export default __webpack_public_path__ + "static/media/BEKAESH.7027f402.png";